import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "../Admin/AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "../Admin/AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import EarningsAreaChart from "../Admin/AdminImage/EarningsAreaChart";

export default function AdminDashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [date, setDate] = useState(new Date());
  const earnings = [3000, 4000, 5000, 7000, 6000, 8000, 9000, 12000, 11000, 15000, 14000, 16000];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allShips, setallShips] = useState([]);
  const [allCat, setallCat] = useState([]);
  const [allSubCat, setallsubCat] = useState([]);
  const [allAm, setallAm] = useState([]);
  const [allImages,setAllImages] = useState([])
  const [selectedShip, setSelectedShip] = useState(null); // State for selected ship

  const [allShipsReg, setallShipsReg] = useState([]);
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

const [allChart,setAllChart] = useState([])

useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForCharter`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAllChart(res1.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res1.data.status === 200) {
        const fetchedShips = res1.data.data;
        const currentShipCount = fetchedShips.length;

        // Check if a new ship was added AFTER the last seen count
        if (currentShipCount > prevShipCount) {
          setNewShip(true);
          localStorage.setItem("newShip", JSON.stringify(true));
          localStorage.setItem("prevShipCount", JSON.stringify(currentShipCount));
        }

        setallShipsReg(fetchedShips);
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();

  // Polling every 5 seconds
  const interval = setInterval(fetchData, 5000);

  return () => clearInterval(interval);
}, [prevShipCount]); // Only depend on prevShipCount to avoid unnecessary updates

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShipsReg.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
};

const [allEq,setAllEq] = useState([])
useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForEquipments`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAllEq(res1.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);



  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :",res3);
          setAllImages(res3.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShip`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallCat(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // sub category
  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallsubCat(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // amenities
  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallAm(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  const navigate = useNavigate()
  
  const recentShip = allShips.length > 0 ? allShips[0] : null;
  const recentShipImage = allImages.length > 0 ? allImages[0] : null;

  
  const displayedShipimage = selectedShip || (allImages.length > 0 ? allImages[0] : null);

  // Add an identifier to distinguish Admin Ships and Customer Ships
const filteredAllShipsReg = allShipsReg
.filter((ship) => ship.is_allow)
.map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale

const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship

// Merge and sort ships by created_at (latest first)
const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
(a, b) => new Date(b.created_at) - new Date(a.created_at)
);


const displayedShip = selectedShip || (sortedData.length > 0 ? sortedData[0] : null);

const [allImagesReg,setAllImagesReg] = useState([])
  
    useEffect(() => {
      async function fetchdata() {
        try {
          const res3 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }
            }
          );
          if (res3.data.status === 200) {
            console.log("Images :",res3);
            setAllImagesReg(res3.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url]);

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

         {/* Menu Button (Moves on Sidebar Toggle) */}
                <button
                  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  className={`absolute xm:hidden transition-all duration-300 text-white ${
                    isSidebarOpen ? "left-60" : "left-16"
                  }`}
                >
                  <Menu size={28} />
                </button>

             {/* mobile screen menu button */}
                    <button
                      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                      className={`absolute xm:block hidden transition-all duration-300 text-white ${
                        isSidebarOpen ? "left-32" : "left-16"
                      }`}
                    >
                      <Menu size={28} />
                    </button>

                   

        {/* Admin Profile (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}
          <div className="relative">
             <div>
                      <Link className="bg-gray-200 p-2 rounded" to={'/admin/users'}>See All Users</Link>
                    </div>
            {/* Envelope Icon with Blinking Dot */}
            {/* <div className="cursor-pointer relative" onClick={toggleDropdownNotification}>
              <i className="fa-regular fa-envelope text-[28px] text-gray-500"></i>

              
            </div> */}

            {/* Notification Dropdown */}
            {/* {isOpennoti && (
              <div
                ref={dropdownRef}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-48 py-2 origin-top transition-transform duration-300 scale-y-100 opacity-100"
                style={{ transformOrigin: "top" }}
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    Check Notifications
                  </li>
                </ul>
              </div>
            )} */}
          </div>
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
          }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className="px-4 py-2 text-lg  text-[#00c292] border-l-4 border-[#00c292] flex items-center">
              <i className="fa-solid fa-gauge mr-3"></i>
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>

            {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}

            {/* Ship For Sale Dropdown */}
            <li className="px-2  text-lg  flex flex-col  relative">
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                 <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

             <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                   <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Open Cargo </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo' >Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo' >Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                   <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Supply Equipments </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

              {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
              {isSidebarOpen && <ul className="px-2  text-lg flex flex-col relative group">
         <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>}


            

            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-gear"></i>
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* mobile screen sidebar */}

        <div
          className={`fixed hidden   xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
            isMobile
              ? isSidebarOpen
                ? "w-full  translate-x-0" // Open in full width on mobile
                : "-translate-x-full w-0" // Hide sidebar on mobile
              : isSidebarOpen
              ? "w-60 translate-x-0" // Open normally on desktop
              : "w-0" // Hide sidebar on desktop
          }`}
        >
          <ul className="mt-10 flex  flex-col gap-3 ">
            {/* Dashboard */}
            <li className={`px-4 py-2 text-lg text-[#00c292] ${
                isSidebarOpen ? "border-l-4 border-[#00c292]" : "border-none"
              }  flex items-center`}>
              {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>
               {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
            {/* Ship For Sale Dropdown */}
            <li
              className={`px-2  text-lg  flex flex-col  relative`}
            >
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

             <li className="px-3  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Open Cargo</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Supply Equipments</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg flex flex-col relative group">
  {/* Clickable Div */}
 {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}

              {isSidebarOpen && <ul className="px-2 py-2  text-lg flex gap-3
               flex-col relative group">
         <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>
  }

  {/* Click Dropdown (For open sidebar) */}
  {isSidebarOpen && (
    <div
      className={`ml-6 mt-2 transition-all duration-300 ${
        openDropdown === 5
          ? "max-h-48 opacity-100 "
          : "max-h-0 opacity-0 overflow-hidden"
      }`}
    >
     <ul>
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>
    </div>
  )}
</li>


            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto py-4 ">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
          <div className="flex justify-between items-center">
              <h1>Dashboard</h1>
              <div className="flex text-sm gap-2">
               <Link to={'/adminHome'}>Home</Link> <span>/</span>
               <p className="text-[#00c292]">Dashboard</p>
              </div>
            </div>
          </div>
          <div className="p-5 xm:p-2">
        {/* content ship */}
        <div className=" transition-all duration-300 ">
          {/* Add main content here */}
          
          <div className='  2xl:px-0 '><hr className=' border-1 border-[#afe9fd]'/></div>

          <div className="2xl:px-5 2xl:flex-wrap flex gap-10 mt-4">
      {/* Ship List */}
      <div className="w-[340px] px-2 overflow-y-auto xm:w-[100%]   sm:m-auto 2xl:m-auto 2xl:mt-5  h-[400px]">
        <div className="flex justify-between">
          <h1 className="text-xl text-gray-700 font-bold">Ship List</h1>
          <select className="bg-[#f4fcff]">
            <option value="">Today</option>
          </select>
        </div>

        {/* Ship Details List */}
        <div className="2xl:border xm:w-full w-[240px] overflow-x-hidden cursor-pointer 2xl:rounded-lg 2xl:border-[#a3e5fc] 2xl:px-1 2xl:mt-3">
  {sortedData.map((itm) => (
    <div
      key={`${itm.id}-${itm.isFromReg ? "reg" : "admin"}`}
      className={`mt-5 xxxm:flex-wrap xxxm:gap-3 flex justify-between items-center rounded-lg px-2 py-2 transition-all duration-200 ${
        displayedShip?.id === itm.id && displayedShip?.isFromReg === itm.isFromReg
          ? "border-2 border-[#afe9fd]"
          : "border-2 border-transparent"
      }`}
      onClick={() => setSelectedShip(itm)}
    >
      <div className="min-w-[200px]">
        <div className="flex gap-2 items-center">
          {(() => {
            let imageUrl = null;

            if (itm.isFromReg) {
              const regImgs = allImagesReg.filter((img) => img.ships === itm.id);
              imageUrl = regImgs.length > 0 ? regImgs[0].image : null;
            } else {
              const saleImgs = allImages.filter((img) => img.ship === itm.id);
              imageUrl = saleImgs.length > 0 ? saleImgs[0].image : null;
            }

            return imageUrl ? (
              <img
                src={imageUrl}
                alt="Ship Thumbnail"
                className="w-[50px] h-[40px] rounded-full border-2 border-green-500 bg-white"
              />
            ) : null;
          })()}
          <div>
            <h1 className="font-bold text-sm">
              { itm.short_description}
            </h1>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>


      </div>

      {/* Ship Details */}
      <div className="sm:m-auto xxxm:overflow-x-auto ">
        <h1 className="font-bold text-xl text-gray-700">Ship Details</h1>
        {displayedShip ? (
          <div className="mt-5 border w-[500px] md:w-auto xxxm:overflow-x-auto shadow-lg border-green-500 px-4 py-3 rounded-lg">
            <div className="flex items-center gap-3">
            <img
              src={
                displayedShip?.isFromReg
                  ? allImagesReg.find((img) => img.ships === displayedShip.id)?.image
                  : allImages.find((img) => img.ship === displayedShip.id)?.image
                || "fallback-image-url"
              }
              className="w-[60px] h-[60px] border-2 border-green-500 rounded-full"
              alt="Ship Thumbnail"
            />
              <div>
                <h1 className="font-bold text-xl">{displayedShip.short_description}</h1>
              </div>
            </div>

            <div className="mt-10 flex gap-16 flex-wrap sm:gap-3 items-center justify-between">
              <h1 className="font-bold">Ship Type</h1>
              <div className="flex gap-10">
                <h1 className="font-semibold text-gray-700">{displayedShip.vessel_type || "N/A"}</h1>
              </div>
            </div>

            <div className="mt-10 flex gap-16 sm:gap-6 justify-between">
              <h1 className="font-bold">Flag</h1>
              <div className="flex gap-5">
                <p className="text-gray-700">{displayedShip.flag || "N/A"}</p>
              </div>
            </div>

            <div className="mt-10 flex gap-16 sm:gap-6 justify-between">
              <h1 className="font-bold">Built Year</h1>
              <div className="flex gap-5">
                <p className="text-gray-700">{displayedShip.year_built || "N/A"}</p>
              </div>
            </div>

            <div className="mt-10 pr-0 flex sm:gap-6 justify-between">
              <h1 className="font-bold">Short Description</h1>
              <div >
                <p className="text-gray-700 ">{displayedShip.short_description || "No description available"}</p>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-gray-600 mt-5">No ship data available.</p>
        )}
      </div>

      {/* Calendar Section */}
      <div className="xm:overflow-x-auto 2xl:m-auto lg:m-0">
        <h1 className="font-bold text-xl text-gray-700">Calendar</h1>
        <div className="mt-5 border border-gray-300 rounded-lg p-4 bg-[#f4fcff] shadow">
          <Calendar
            onChange={setDate}
            value={date}
            className="rounded-lg bg-[#f4fcff]"
            showNeighboringMonth={false}
          />
          <p className="mt-4 text-gray-600 text-sm">
            Selected Date: <span className="font-semibold text-gray-800">{date.toDateString()}</span>
          </p>
        </div>
      </div>
    </div>


        </div>

        <div className="flex mt-8 justify-around  xxxm:overflow-x-auto  sm:justify-center   flex-wrap gap-10  items-center">
          {/* ship */}   
              <div onClick={()=>navigate('/admin/viewShip')} className="w-[250px] sm:w-full  py-[10px] bg-[#f97276] shadow-lg items-center cursor-pointer hover:bg-[#ee565b] max-h-screen rounded-lg  ">
                <div className="flex  xxxm:flex-wrap-reverse px-[20px] justify-between items-center">
                  <div className='flex flex-col gap-2'>
                    <p className="text-xl text-white">Ship List</p>
                    <div className='flex gap-4 '>
                      <h1 className='text-white font-bold text-2xl'>{allShips.length}</h1>
                      <div className='flex flex-col'>
                        <i className="fa-duotone font-bold mt-2 text-white fa-solid fa-chart-line"></i>
                        <h1 className='text-white'>+4%</h1>
                        </div>
                    </div>
                    
                    </div>
                  <i className="bx bx-home  border-2 border-gray-200 text-2xl px-3 py-2 rounded-full text-white font-semibold"></i>
                </div>
              </div>
            
           

          {/* cat */}
          
          
              
           
            <div onClick={()=>navigate('/admin/shipforCharter')} className="w-[250px] sm:w-full py-[10px] bg-[#46bc62] shadow-lg items-center cursor-pointer hover:bg-[#3d7e4c] max-h-screen rounded-lg  ">
                <div className="flex  xxxm:flex-wrap-reverse px-[20px] justify-between items-center">
                  <div className='flex flex-col gap-2'>
                    <p className="text-xl text-white">Charter list</p>
                    <div className='flex gap-4 '>
                      <h1 className='text-white font-bold text-2xl'>{allChart.length}</h1>
                      <div className='flex flex-col'>
                        <i className="fa-duotone font-bold mt-2 text-white fa-solid fa-chart-line"></i>
                        <h1 className='text-white'>+.4%</h1>
                        </div>
                    </div>
                    
                    </div>
                  <i className="fa-solid  border-2 border-gray-200 fa-list text-2xl px-3 py-2 rounded-full text-white font-bold"></i>
                </div>
              </div>
          
         

          {/* sub cat */}
          
          
            <div onClick={()=>navigate('')} className="w-[250px] sm:w-full py-[10px] bg-[#74b4d1] shadow-lg  items-center cursor-pointer hover:bg-[#3d7f9b] max-h-screen rounded-lg  ">
                <div className="flex px-[20px]  xxxm:flex-wrap-reverse justify-between items-center">
                  <div className='flex flex-col gap-2'>
                    <p className="text-xl text-white">Open Cargo</p>
                    <div className='flex gap-4 '>
                      <h1 className='text-white font-bold text-2xl'>0</h1>
                      <div className='flex flex-col'>
                        <i className="fa-duotone font-bold mt-2 text-white fa-solid fa-chart-line"></i>
                        <h1 className='text-white'>+.2%</h1>
                        </div>
                    </div>
                    
                    </div>
                    <i className="fa-solid  border-2 border-gray-200 fa-list text-2xl px-3 py-2 rounded-full text-white font-semibold"></i>
                </div>
              </div>
          
         
              {/* amenities */}
            
              <div onClick={()=>navigate('/admin/shipforEq')} className="w-[250px] sm:w-full py-[10px] bg-[#c58dd7] shadow-lg  items-center cursor-pointer hover:bg-[#c36ae1] max-h-screen rounded-lg  ">
                <div className="flex px-[20px]  xxxm:flex-wrap-reverse justify-between items-center">
                  <div className='flex flex-col gap-2'>
                    <p className="text-xl text-white">Equipments</p>
                    <div className='flex gap-4 '>
                      <h1 className='text-white font-bold text-2xl'>{allEq.length}</h1>
                      <div className='flex flex-col'>
                        <i className="fa-duotone font-bold mt-2 text-white fa-solid fa-chart-line"></i>
                        <h1 className='text-white'>+.5%</h1>
                        </div>
                    </div>
                    
                    </div>
                    <i className="fa-solid  border-2 border-gray-200 fa-gauge text-2xl px-3 py-2 rounded-full text-white font-semibold"></i>
                </div>
              </div>
            
        </div>


        {/* chart */}

        <div className='  xxxm:overflowx-auto overflow-y-hidden mt-10  mb-10 '>
          <EarningsAreaChart  earningsData={earnings} />
          </div>

          </div>
        </div>
      </div>
    </div>
  );
}
